var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"newsitem"},[_c('span',{staticClass:"newsitem-date"},[_vm._v(_vm._s(_vm.date))]),_c('div',{staticClass:"newsitem-body"},[_c('div',{staticClass:"newsitem-content",domProps:{"innerHTML":_vm._s(_vm.newsItemData.content.rendered)}}),_c('div',{staticClass:"newsitem-footer"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }